import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { LedgerType } from 'src/pages/pto/types';
import IconButton from '../common/IconButton';


export interface IProps {
    isUpdating: boolean;
    showPTODeletePrompt: boolean;
    setShowPTODeletePrompt: Function;
    setDeletePTOEntry: Function;
    entryToDelete: LedgerType;
    deleteLedgerEntry: Function;
    requestString: string;
}


const PTODeletePrompt: React.FC<IProps> = (props) => {
    const { isUpdating, showPTODeletePrompt, setShowPTODeletePrompt, entryToDelete, deleteLedgerEntry, requestString } = props;


    return (
        <Modal show={showPTODeletePrompt} centered>
            <Modal.Header>
                <h5>PTO Delete</h5>
            </Modal.Header>
            <Modal.Body>
                Delete This PTO Entry?
            </Modal.Body>
            <Modal.Footer>
            <IconButton disabled={isUpdating} onClick={() => setShowPTODeletePrompt(!showPTODeletePrompt)} buttonClassName="action-text-danger" icon="close">Cancel</IconButton>
                {
                    isUpdating ?
                        <Spinner size="sm" animation="border" />
                        : <IconButton disabled={isUpdating} showSpinner={isUpdating} onClick={(e) => deleteLedgerEntry(entryToDelete, requestString)} buttonClassName="action-text" icon="save">
                            Delete
                        </IconButton>
                }
            </Modal.Footer>
        
        </Modal>
    )
}
export default PTODeletePrompt;